module.exports = __webpack_public_path__ + "67d640781177e9722e7c27ae6dbc1b1a.svg";